<template>
  <div
    class="box"
    :class="{ 'p-5 sv-pad': ['authenticated'].includes(layoutName) }"
  >
    <div class="mb-4">
      <h3 v-if="error.statusCode === 404">
        {{ $t('error.404') }}
      </h3>
      <h3 v-else-if="error.statusCode === 429">
        {{ $t('error.429') }}
      </h3>
      <h3 v-else>
        {{ $t('error.others') }}
      </h3>
    </div>
    <nuxt-link to="/redirect">
      {{ $t('error.back') }}
    </nuxt-link>
  </div>
</template>

<script>
export default {
  props: ['error'],

  layout({ store }) {
    const isAuthenticated = store.getters['auth/isAuthenticated']
    return isAuthenticated ? 'authenticated' : 'public'
  },

  mounted() {
    this.$oneplaceHelper.initNavbar('ERROR')
  },

  computed: {
    layoutName() {
      return this.$root.layoutName
    }
  }
}
</script>

<style lang="scss" scoped>
.sv-container {
  padding-top: calc(#{$navbar-height} + 1.5rem);
}

.sv-pad {
  margin-top: 1.5rem;
}

.box {
  background: white;
  color: black;
}

.bg {
  height: calc(100vh - #{$footer-height});
  background: url(~@/assets/country/bg.jpg) bottom no-repeat;
  background-size: cover;
  position: relative;
  color: white;
  z-index: 1;

  .layer {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;

    background: $bg-layer-color;
    opacity: 0.8;
    height: 20%;
    z-index: 0;
  }
}
</style>
